// ABOUTME: Onboarding flow for adults who joined via invitation.
// ABOUTME: Shows educational wizard videos without data entry since family is already configured.

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Button,
  Container,
  MobileStepper,
  Typography,
} from '@mui/material';
import { KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material';
import VideoPlayer from './VideoPlayer';

const STEPS = [
  {
    videoFile: 'family-wizard-welcome.mp4',
    title: 'Welcome to BePono!',
    description: "You've joined your family. Here's how BePono works.",
  },
  {
    videoFile: 'family-wizard-add-adults.mp4',
    title: 'Working Together as a Family',
    description: 'See how adults collaborate to support children in the app.',
  },
  {
    videoFile: 'family-wizard-review-goals.mp4',
    title: 'Goals and Progress',
    description: "Here's how your family tracks goals and celebrates progress.",
  },
];

const InvitedUserOnboarding: React.FC = () => {
  const navigate = useNavigate();
  const [activeStep, setActiveStep] = useState(0);
  const maxSteps = STEPS.length;

  const handleNext = () => setActiveStep((prev) => prev + 1);
  const handleBack = () => setActiveStep((prev) => prev - 1);
  const handleComplete = () => navigate('/');

  const currentStep = STEPS[activeStep];

  return (
    <Container maxWidth="md">
      <Box mt={4}>
        <Typography variant="h4" gutterBottom textAlign="center">
          {currentStep.title}
        </Typography>
        <Typography variant="body1" color="text.secondary" textAlign="center" mb={3}>
          {currentStep.description}
        </Typography>

        <VideoPlayer videoFile={currentStep.videoFile} />

        <MobileStepper
          variant="dots"
          steps={maxSteps}
          position="static"
          activeStep={activeStep}
          sx={{ mt: 3 }}
          nextButton={
            activeStep === maxSteps - 1 ? (
              <Button size="small" variant="contained" onClick={handleComplete}>
                Get Started
              </Button>
            ) : (
              <Button size="small" onClick={handleNext} endIcon={<KeyboardArrowRight />}>
                Next
              </Button>
            )
          }
          backButton={
            <Button
              size="small"
              onClick={handleBack}
              disabled={activeStep === 0}
              startIcon={<KeyboardArrowLeft />}
            >
              Back
            </Button>
          }
        />
      </Box>
    </Container>
  );
};

export default InvitedUserOnboarding;
